module.exports = __webpack_public_path__ + "static/media/BN.bc5e2062.png";